export default __webpack_public_path__ + "static/media/strom_barva-min.8268e4ee.png";